module.exports = __webpack_public_path__ + "static/img/1614x746.3a60341.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/1614x746.png
// module id = wJF1
// module chunks = 0